// extracted by mini-css-extract-plugin
export var cardHeader = "_ix-0";
export var reorderHandle = "_ix-3";
export var titleArea = "_ix-1";
export var titleAreaWithHandle = "_ix-2";